/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Status_ClosedInputs */



/**
* | output |
* | --- |
* | "Closed" |
*
* @param {Manual_Qc_Status_ClosedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_status_closed = /** @type {((inputs?: Manual_Qc_Status_ClosedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Status_ClosedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermee")
	if (locale === "de") return /** @type {LocalizedString} */ ("Geschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiuso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрыто")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭")
	if (locale === "ja") return /** @type {LocalizedString} */ ("閉鎖")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बंद किया हुआ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechado")
	return /** @type {LocalizedString} */ ("Closed")
});